
import React, {Dispatch, SetStateAction} from "react"
import Image from "next/image"
import {useTranslation} from "next-i18next"
import {ArrowLeft, ArrowRight} from "react-bootstrap-icons"
import Typography from "../../../reusable/Typography/Typography"
import Button from "../../../reusable/components/Button"
import {useRouter} from "next/router"

function QuizzSubmitSuccess() {
	const {t} = useTranslation()
	const router = useRouter()
	return (
		<div className=" d-flex flex-column justify-content-start container  align-items-start gap-2 text-black  p-3 "
			style={{border: "1px solid #fefefe", borderRadius: "8px"}} >
			<Typography style={{fontSize: "20px", lineHeight: "32px"}}
				variant="bodySmBlack"
				className="d-flex align-items-center justify-content-start gap-1">{t("quiz-success-title")}</Typography>

			<Typography style={{fontSize: "14px", lineHeight: "20px", maxWidth: "640px"}}
				variant="bodySm">{t("quiz-success-header")}</Typography>

			<Typography style={{fontSize: "14px", lineHeight: "20px"}}
				variant="bodySm">{t("quiz-success-subheader")}</Typography>

			<Button bgColor="#FEC04D"
				fontSizeSmall
				className="col-12 mt-2"
				onClick={() => {
					router.replace("/")
				}}
				label={t("go-to-homepage")} />
		</div>
	)
}

export default QuizzSubmitSuccess
